import { render, staticRenderFns } from "./NewLocationDeliveryInput.vue?vue&type=template&id=10cf06ba&lang=pug"
import script from "./NewLocationDeliveryInput.vue?vue&type=script&lang=ts"
export * from "./NewLocationDeliveryInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlacesSearchRefined: require('/app/components/vantone/PlacesSearchRefined.vue').default,TextInputError: require('/app/components/generic/forms/TextInputError.vue').default})
